<template>
<v-card class='mb-5' >
  <v-card-title class='subtitle-1 overline' >
    Form Submissions
    <!-- {{relationshipId}} -->
    <v-spacer></v-spacer>
    <share-form :relationship-id='relationshipId' ></share-form>
    <!-- <v-btn to='/integrations/jotform' flat >Manage integration</v-btn> -->
    <v-btn icon small @click='getSubmissions' :loading='request.loading' >
      <v-icon small>replay</v-icon>
    </v-btn>
  </v-card-title>
  <template >
    <v-list dense class='pa-0 elevation-0 my-4' >
      <template v-for="submission in submissions" >
      <v-list-tile
        @click="selectedSubmission=submission;submissiondetaildialog=true"
        :key="submission.submission_id" >
        <v-list-tile-content>
          <v-list-tile-title v-if="submission.form"
            v-text="submission.form.title" >
          </v-list-tile-title>
          <v-list-tile-title v-else >
            <v-icon small color="info" >info</v-icon>
            Form is no longer linked, or no longer exists
          </v-list-tile-title>
          <v-list-tile-sub-title>
            Submitted: {{ dateformat(submission.created_date) }}
          </v-list-tile-sub-title>
        </v-list-tile-content>
        <v-list-tile-action >
          <v-btn flat small
            @click.stop='confirmSync=true' >Re-Sync</v-btn>
        </v-list-tile-action>

        <v-dialog v-model='confirmSync' width='450' >
          <request-status :request='syncRequest' :message200='false' @ok='confirmSync=false' />
          <v-card>
            <v-card-title class='subtitle-1 overline' >
              Sync this submission to AppointmentGuru client
              <v-spacer />
              <v-btn @click='confirmSync=false' icon small ><v-icon small >close</v-icon></v-btn>
            </v-card-title>
            <v-card-text>
              <p>This will sync the data from the form submission with their AppointmentGuru client information
              such as their contact information and medical aid information.</p>
              <p><strong>Note</strong> Normally you should not need to perform this step manually as
              the information is typically automatically synced when the submission is received</p>
            </v-card-text>
            <v-card-actions>
              <v-btn flat @click='confirmSync=false' >Cancel</v-btn>
              <v-spacer></v-spacer>
              <v-btn color='primary'
                :loading='syncRequest.loading'
                @click='sync(submission)' >Sync</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-list-tile-action v-if='submission.submission_id && submission.form && submission.form.form_id' >
          <v-btn
            @click.stop='noop'
            :href='`https://jotform.com/inbox/${submission.form.form_id}/${submission.submission_id}`'
            target='_blank' icon small >
            <v-icon small>open_in_new</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
      </template>

      <v-list-tile v-if='submissions && submissions.length === 0' class='mb-5' >
        <v-list-tile-content>
          <v-list-tile-title>No linked submissions found.
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-dialog v-model='showSubmissionPicker' width='460' >
        <assign-submission
          :relationship-id='relationshipId'
          @close='showSubmissionPicker=false'
          @ok='getSubmissions' >
          <v-card-actions slot='card-actions' >
            <v-btn @click='showSubmissionPicker=false' flat >Cancel </v-btn>
          </v-card-actions>
        </assign-submission>
      </v-dialog>

    </v-list>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <!-- @click='showSubmissionPicker=true' -->
      <v-btn to='/integrations/jotform' flat >
      <v-icon class='mr-1' >search</v-icon>
        Find a submission
      </v-btn>
      <v-btn to='/integrations/jotform' flat >Manage integration</v-btn>
    </v-card-actions>
  </template>

  <v-dialog v-model="submissiondetaildialog" >
    <form-submission-card with-close
      v-if="selectedSubmission"
      @close="submissiondetaildialog=false"
      :submission-id="selectedSubmission.submission_id"
      :key="selectedSubmission.submission_id" />
  </v-dialog>

</v-card>
</template>
<script>
import FormSubmissionCard from '@/components/cards/FormSubmissionCard.vue'
import AssignSubmission from '@/components/pages/Integrations/JotForm/AssignSubmission.vue'
import ShareForm from '@/components/client/forms/ShareForm.vue'
import RequestStatus from '@/components/ui/RequestStatus'

export default {
  name: 'ClientForms',
  components: {
    FormSubmissionCard,
    ShareForm,
    AssignSubmission,
    RequestStatus
  },
  props: {
    relationshipId: { required: true }
  },
  data () {
    return {
      request: {
        resource: 'ag.spaces.relationships',
        extra: 'submissions',
        data: {}
      },
      syncRequest: {
        resource: 'ag.integrations',
        extra: 'jotform/assign_submission'
      },
      confirmSync: false,
      showSubmissionPicker: false,
      showShare: false,
      submissiondetaildialog: false,
      selectedSubmission: null
    }
  },
  watch: {
    relationshipId: {
      immediate: true,
      handler () {
        if (this.relationshipId) {
          this.getSubmissions()
        }
      }
    }
  },
  computed: {
    integration () {
      return this.$store.getters.getIntegration('JotForm')
    },
    submissions () {
      return this.request.result
    }
  },
  methods: {
    noop () {},
    sync (submission) {
      this.syncRequest.method = 'post'
      this.syncRequest.data = {
        relationship_id: this.relationshipId,
        submission_id: submission.submission_id,
        form_id: submission.form.id
      }
      this.$request('save', this.syncRequest)
    },
    getSubmissions () {
      this.request.resourceId = this.relationshipId
      this.$request('get', this.request)
    }
  }
}
</script>



// WEBPACK FOOTER //
// ClientForms.vue?0e3f4764